// "Ver como instructor": el admin abre /mi-calendario?id=<instructorId>&ver=1
// y la app se muestra como la ve ese instructor (menú reducido, sin barra admin).
// El estado vive solo en la URL: al navegar a otra página el modo se apaga solo.
// Es solo visual: no cambia la sesión ni los permisos reales.

export const isViewAsInstructor = (user, location) => {
    if (user?.role !== 'admin' || location?.pathname !== '/mi-calendario') return false;
    const params = new URLSearchParams(location.search);
    return params.get('ver') === '1' && !!params.get('id');
};

// Usuario "como instructor" para construir menús.
export const asInstructorUser = (user) => ({ ...user, role: 'instructor', isInstructor: true, isCollaborator: false });

export const viewAsUrl = (instructorId) => `/mi-calendario?id=${instructorId}&ver=1`;
